import { Theme } from '@mui/material';
import { Colors } from '../../../utils/theme';

export const createOwnEventSectionStyles = (theme: Theme) => ({
	root: {
		display: 'flex',
		flexDirection: { xs: 'column', md: 'row' },
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: { xs: '50px', md: '105px' },
		pt: { xs: '60px', md: '85px' },
		px: { xs: '30px', lg: '60px' },
	},
	title: {
		fontFamily: 'Integral CF',
		fontSize: { xs: '20px', lg: '24px' },
		fontStyle: 'italic',
		color: '#120E0D',
		fontWeight: 600,
		textTransform: 'uppercase',
		textAlign: 'left',
	},
	subtitle: {
		fontFamily: 'Montserrat',
		fontSize: { xs: '16px', lg: '18px' },
		fontWeight: '600',
		lineHeight: '1.25',
		color: Colors['6D7275'],
		wordWrap: 'break-word'
	},
	button: {
		height: 'fit-content',
		lineHeight: '22px',
		padding: '12px 32px',
		textTransform: 'none'
	},
	createEventButton: {
		backgroundColor: '#F84B0B',
		borderColor: '#F84B0B',
		color: 'white',
	}
});
